
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dasbor",
      function () {
        return require("private-next-pages/dasbor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dasbor"])
      });
    }
  